import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsStackpathComponent } from './simple-icons-stackpath.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsStackpathComponent ],
    exports:      [ SimpleIconsStackpathComponent ],
    bootstrap:    []
})
export class SimpleIconsStackpathModule {}
